import { BaseObj } from '@/objects/BaseObj';
import { useBaseObjEntityStateHandler } from '@/objects/entitystatehandler/entitystatehandler';
import { isRef, ref, unref } from 'vue';
import type { EntityState } from './../enums/EntityState';

export class FISDataRace extends BaseObj {
    public ID: number;
    public __id: number;

    public Code: string | null;
    public __code: string | null;

    public Distance: number | null;
    public __distance: number | null;

    public Fisdistanse: number | null;
    public __fisdistanse: number | null;

    public Fisnavn: string | null;
    public __fisnavn: string | null;

    public Hd: number | null;
    public __hd: number | null;

    public Kommentar: string | null;
    public __kommentar: string | null;

    public Mm: number | null;
    public __mm: number | null;

    public Name: string | null;
    public __name: string | null;

    public Rundelengde: number | null;
    public __rundelengde: number | null;

    public Runder: number | null;
    public __runder: number | null;

    public Tc: number | null;
    public __tc: number | null;

    public __entityStateHandler;
    public __selfEntityState: EntityState;
    public __entityState: any;
    public get EntityState(): EntityState {
        return unref(this.__entityState);
    }
    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        ID?: number;
        Code?: string | null;
        Distance?: number | null;
        EntityState?: EntityState;
        Fisdistanse?: number | null;
        Fisnavn?: string | null;
        Hd?: number | null;
        Kommentar?: string | null;
        Mm?: number | null;
        Name?: string | null;
        Rundelengde?: number | null;
        Runder?: number | null;
        Tc?: number | null;
    }) {
        super();
        this.__entityState = ref(values.EntityState ?? 'Unchanged');
        this.__selfEntityState = values.EntityState ?? 'Unchanged';
        this.__entityStateHandler = useBaseObjEntityStateHandler<FISDataRace>(unref(this.__entityState), (states) => {
            if (isRef(this.__entityState)) {
                this.__entityState.value = states.EntityStateWithChildrenConsidered;
            } else {
                console.warn('FISDataRace tried to set entitystate, but entitystate is not a ref! This should never happen');
            }
            this.__selfEntityState = states.SelfEntityState;
        });
        this.ID = values.ID ?? 0;
        this.__id = values.ID ?? 0;
        Object.defineProperty(this, 'ID', {
            get(): number {
                return this.__id;
            },
            enumerable: true,
            configurable: true,
        });

        this.Code = values.Code ?? null;
        this.__code = values.Code ?? null;
        Object.defineProperty(this, 'Code', {
            get(): string | null {
                return this.__code;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Code', this.__code, value);
                this.__code = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Distance = values.Distance ?? null;
        this.__distance = values.Distance ?? null;
        Object.defineProperty(this, 'Distance', {
            get(): number | null {
                return this.__distance;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('Distance', this.__distance, value);
                this.__distance = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Fisdistanse = values.Fisdistanse ?? null;
        this.__fisdistanse = values.Fisdistanse ?? null;
        Object.defineProperty(this, 'Fisdistanse', {
            get(): number | null {
                return this.__fisdistanse;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('Fisdistanse', this.__fisdistanse, value);
                this.__fisdistanse = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Fisnavn = values.Fisnavn ?? null;
        this.__fisnavn = values.Fisnavn ?? null;
        Object.defineProperty(this, 'Fisnavn', {
            get(): string | null {
                return this.__fisnavn;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Fisnavn', this.__fisnavn, value);
                this.__fisnavn = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Hd = values.Hd ?? null;
        this.__hd = values.Hd ?? null;
        Object.defineProperty(this, 'Hd', {
            get(): number | null {
                return this.__hd;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('Hd', this.__hd, value);
                this.__hd = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Kommentar = values.Kommentar ?? null;
        this.__kommentar = values.Kommentar ?? null;
        Object.defineProperty(this, 'Kommentar', {
            get(): string | null {
                return this.__kommentar;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Kommentar', this.__kommentar, value);
                this.__kommentar = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Mm = values.Mm ?? null;
        this.__mm = values.Mm ?? null;
        Object.defineProperty(this, 'Mm', {
            get(): number | null {
                return this.__mm;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('Mm', this.__mm, value);
                this.__mm = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Name = values.Name ?? null;
        this.__name = values.Name ?? null;
        Object.defineProperty(this, 'Name', {
            get(): string | null {
                return this.__name;
            },
            set(value: string | null) {
                this.__entityStateHandler.propertyChanged('Name', this.__name, value);
                this.__name = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Rundelengde = values.Rundelengde ?? null;
        this.__rundelengde = values.Rundelengde ?? null;
        Object.defineProperty(this, 'Rundelengde', {
            get(): number | null {
                return this.__rundelengde;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('Rundelengde', this.__rundelengde, value);
                this.__rundelengde = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Runder = values.Runder ?? null;
        this.__runder = values.Runder ?? null;
        Object.defineProperty(this, 'Runder', {
            get(): number | null {
                return this.__runder;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('Runder', this.__runder, value);
                this.__runder = value;
            },
            enumerable: true,
            configurable: true,
        });

        this.Tc = values.Tc ?? null;
        this.__tc = values.Tc ?? null;
        Object.defineProperty(this, 'Tc', {
            get(): number | null {
                return this.__tc;
            },
            set(value: number | null) {
                this.__entityStateHandler.propertyChanged('Tc', this.__tc, value);
                this.__tc = value;
            },
            enumerable: true,
            configurable: true,
        });
    }

    public _setNotifyParentOfModificationCallback(callback: () => void) {
        this.__entityStateHandler.setNotifyParentOfModificationCallback(callback);
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"Code": ${JSON.stringify(this.Code)}` +
            ',' +
            `"Distance": ${JSON.stringify(this.Distance)}` +
            ',' +
            `"EntityState": ${unref(this.__selfEntityState) == 'Unchanged' ? 0 : unref(this.__selfEntityState) == 'Deleted' ? 1 : unref(this.__selfEntityState) == 'Modified' ? 2 : unref(this.__selfEntityState) == 'Added' ? 3 : 0}` +
            ',' +
            `"Fisdistanse": ${JSON.stringify(this.Fisdistanse)}` +
            ',' +
            `"Fisnavn": ${JSON.stringify(this.Fisnavn)}` +
            ',' +
            `"Hd": ${JSON.stringify(this.Hd)}` +
            ',' +
            `"Kommentar": ${JSON.stringify(this.Kommentar)}` +
            ',' +
            `"Mm": ${JSON.stringify(this.Mm)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            ',' +
            `"Rundelengde": ${JSON.stringify(this.Rundelengde)}` +
            ',' +
            `"Runder": ${JSON.stringify(this.Runder)}` +
            ',' +
            `"Tc": ${JSON.stringify(this.Tc)}` +
            ',' +
            `"ChangedColumns": ${unref(this.__selfEntityState) !== 'Modified' ? 'null' : JSON.stringify(this.__entityStateHandler.getChangedPropertiesArray())}` +
            '}'
        );
    }

    /**
     * Sets the entity state to Deleted
     */
    public Delete() {
        if (this.__selfEntityState === 'Added') {
            throw new Error('Cannot delete an object that is in Added state. It has not been saved yet.');
        }
        this.__selfEntityState = 'Deleted';
        this.__entityStateHandler.entityStateChanged(this.__selfEntityState);
    }

    /**
     * Undeletes the object by setting resetting the EntityState
     *
     * If the object has modifications, the new state will be 'Modified', otherwise 'Unchanged'
     */
    public DeleteUndo() {
        this.__selfEntityState = 'Unchanged';
        this.__entityStateHandler.entityStateChanged(this.__selfEntityState);
    }

    /**
     * Sets the entity state to Added
     *
     * Also sets the ID to the supplied ID. If no id parameter supplied, the previous id is kept
     *
     * Note: This does not do anything with the children, so use with caution
     *
     * The use case of this is to make copies of existing objects as new objects without having to fill every field.
     */
    public SetEntityStateAsAddedAndResetId(id?: number) {
        if (this.EntityState !== 'Unchanged') {
            throw new Error('Changing a modified object to Added is not supported.');
        }
        this.__selfEntityState = 'Added';
        if (id !== undefined) {
            this.__id = id;
        }
        this.__entityStateHandler.entityStateChanged(this.__selfEntityState);
    }

    /**
     * Creates an instance of FISDataRace from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        Code?: string | null;
        Distance?: number | null;
        Fisdistanse?: number | null;
        Fisnavn?: string | null;
        Hd?: number | null;
        Kommentar?: string | null;
        Mm?: number | null;
        Name?: string | null;
        Rundelengde?: number | null;
        Runder?: number | null;
        Tc?: number | null;
        EntityState?: 'Added' | 'Unchanged';
    }): FISDataRace {
        return new FISDataRace(values);
    }

    public static _FromServerJson(json: any): FISDataRace {
        return new FISDataRace({
            ID: json.ID,
            Code: json.Code ?? '',
            Distance: json.Distance ?? null,
            Fisdistanse: json.Fisdistanse ?? null,
            Fisnavn: json.Fisnavn ?? '',
            Hd: json.Hd ?? null,
            Kommentar: json.Kommentar ?? '',
            Mm: json.Mm ?? null,
            Name: json.Name ?? '',
            Rundelengde: json.Rundelengde ?? null,
            Runder: json.Runder ?? null,
            Tc: json.Tc ?? null,
            EntityState: 'Unchanged',
        });
    }

    /**
     * Creates an instance of FISDataRace from another instance of FISDataRace.
     * @param other The FISDataRace you want to clone
     * @returns A cloned FISDataRace
     */
    public static FromOther(other: FISDataRace): FISDataRace {
        if (other.EntityState !== 'Unchanged') {
            throw new Error('Cloning an object with EntityState other than Unchanged is not supported');
        }
        return FISDataRace._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return FISDataRace.FromOther(this);
    }

    /**
     * IsPropertyChanged.
     */
    public IsPropertyChanged(
        ...props: (
            | 'ID'
            | 'Code'
            | 'Distance'
            | 'Fisdistanse'
            | 'Fisnavn'
            | 'Hd'
            | 'Kommentar'
            | 'Mm'
            | 'Name'
            | 'Rundelengde'
            | 'Runder'
            | 'Tc'
        )[]
    ) {
        return this.__entityStateHandler.isPropertyChanged(...props);
    }
    static NAME_OF_CLASS = 'FISDataRace';
}
